import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'
import { InventoryState } from './InventoryTypes'

const selectFeature = (state: State) => state.inventory

export const selectInventoryList = createSelector(
  selectFeature,
  (state: InventoryState) => state.inventoryList,
)

export const selectBadges = createSelector(
  selectFeature,
  (state: InventoryState) => state.badge,
)

export const selectSkusList = createSelector(
  selectFeature,
  (state: InventoryState) => state.skusList,
)

export const selectInventoryDetails = createSelector(
  selectFeature,
  (state: InventoryState) => state.inventoryDetails,
)

export const selectInventoryProductDetails = createSelector(
  selectFeature,
  (state: InventoryState) => state.inventoryProductDetails,
)

export const selectConfigsToExecuteInventory = createSelector(
  selectFeature,
  (state: InventoryState) => state.configsToExecuteInventory,
)

export const selectInventoriesToExecute = createSelector(
  selectFeature,
  (state: InventoryState) => state.inventoriesToExecute,
)

export const selectDataPosition = createSelector(
  selectFeature,
  (state: InventoryState) => state.dataPosition,
)

export const selectDataToExecuteInventory = createSelector(
  selectFeature,
  (state: InventoryState) => state.dataToExecuteInventory,
)

export const selectIsThirdCount = createSelector(
  selectFeature,
  (state: InventoryState) => state.isThirdCount,
)

export const selectGoToPosition = createSelector(
  selectFeature,
  (state: InventoryState) => state.goToPosition,
)

export const selectGoToTableInventories = createSelector(
  selectFeature,
  (state: InventoryState) => state.goToTableInventories,
)

export const selectClickExecuteInventory = createSelector(
  selectFeature,
  (state: InventoryState) => state.clickExecuteInventory,
)

export const selectNeedGetPosition = createSelector(
  selectFeature,
  (state: InventoryState) => state.needGetPosition,
)

export default selectFeature
